
export const getRootDomain = () => {
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(location.host.split(':')[0])) {
        return location.host.split(':')[0];
    } else if (location.host.indexOf('localhost') != -1) {
        return 'localhost';
    } else {
        var temp = location.host.split('.').reverse();
        return '.' + temp[1] + '.' + temp[0];
    }
}
export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


// WEBPACK FOOTER //
// ./src/utils/auth.ts